/* War Record — Shipping redirect interceptor v2
 * For 'Comprar ahora' (dynamic checkout): adds item to cart FIRST,
 * then redirects — so the envio page sees the full cart.
 */
(function () {
  'use strict';

  var TARGET = '/pages/envio';
  var MIN_ARS = 30000; // ARS minimo para envio a domicilio

  // ── Cart page UX injection ─────────────────────────────────────────
  // On /cart: rename the checkout button and add a shipping notice
  function injectCartNotice() {
    if (window.location.pathname !== '/cart') return;

    function tryInject() {
      // 1. Rename the checkout button
      var checkoutBtns = document.querySelectorAll('button[name="checkout"], a[href="/checkout"]');
      checkoutBtns.forEach(function(btn) {
        if (btn.tagName === 'BUTTON' && btn.getAttribute('data-wr-patched') !== '1') {
          btn.setAttribute('data-wr-patched', '1');
          btn.textContent = 'Continuar con el pedido →';
        }
      });

      // 2. Show shipping threshold notice below cart totals
      if (document.getElementById('wr-cart-ship-notice')) return;
      var totalEl = document.querySelector('.totals, .cart__totals, [data-cart-totals]');
      if (!totalEl) return;

      // Try to read subtotal from /cart.js
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
        var subtotalARS = cart.total_price / 100;
        var notice = document.createElement('p');
        notice.id = 'wr-cart-ship-notice';
        notice.style.cssText = 'margin:.8rem 0 0;font-size:.82rem;color:#444;font-family:monospace;border-left:3px solid #009FB0;padding:.5rem .8rem;background:rgba(0,159,176,.04);';
        if (subtotalARS < MIN_ARS) {
          var diff = (MIN_ARS - subtotalARS).toLocaleString('es-AR', {minimumFractionDigits:0, maximumFractionDigits:0});
          notice.innerHTML = '<strong>\u{1F4E6} Envío a domicilio disponible desde $30.000</strong><br>Te faltan $' + diff + ' para habilitar el envío.';
        } else {
          notice.innerHTML = '✔ Pedído habilita envío a domicilio por OCA, Andreani o Correo Argentino.';
          notice.style.borderLeftColor = '#22c55e';
        }
        totalEl.appendChild(notice);

        var hint = document.createElement('p');
        hint.style.cssText = 'margin:.4rem 0 0;font-size:.75rem;color:#666;font-family:monospace;';
        hint.textContent = 'Al continuar vas a elegir entre retiro en el local (gratis) o envío a domicilio.';
        totalEl.appendChild(hint);
      }).catch(function(){});
    }

    // Run after DOM is ready, retry for dynamic carts
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tryInject);
    } else {
      tryInject();
      setTimeout(tryInject, 800);
    }
  }

  injectCartNotice();

  // ── Form submit: intercept cart checkout submit ────────────────────
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (
      form &&
      (form.id === 'cart' || (form.action && form.action.indexOf('/cart') !== -1)) &&
      form.querySelector('[name="checkout"]')
    ) {
      e.preventDefault();
      e.stopImmediatePropagation();
      // Tracking: begin_checkout
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'begin_checkout' });
      if (typeof fbq !== 'undefined') { fbq('track', 'InitiateCheckout'); }
      window.location.href = TARGET;
    }
  }, true);

  // ── Click: intercept checkout buttons, /checkout links, dynamic buttons ──
  document.addEventListener('click', function (e) {
    var el = e.target;

    // Dynamic checkout buttons ("Comprar ahora", ShopPay, PayPal, etc.)
    if (el.closest && el.closest('.shopify-payment-button, .additional-checkout-buttons')) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var form = el.closest('form');
      if (form) {
        var variantInput = form.querySelector('input[name="id"]');
        var qtyInput     = form.querySelector('input.quantity__input, input[name="quantity"]');
        var variantId    = variantInput ? parseInt(variantInput.value) : 0;
        var qty          = qtyInput     ? (parseInt(qtyInput.value) || 1) : 1;

        if (variantId > 0) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: qty })
          }).finally(function () {
            window.location.href = TARGET;
          });
          return;
        }
      }

      window.location.href = TARGET;
      return;
    }

    // Regular checkout button (name="checkout") or /checkout links
    while (el && el !== document.documentElement) {
      if (
        (el.tagName === 'BUTTON' && el.name === 'checkout') ||
        (el.tagName === 'A' && el.href && el.href.indexOf('/checkout') !== -1)
      ) {
        e.preventDefault();
        e.stopImmediatePropagation();
        // Tracking: begin_checkout
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'begin_checkout' });
        if (typeof fbq !== 'undefined') { fbq('track', 'InitiateCheckout'); }
        window.location.href = TARGET;
        return;
      }
      el = el.parentElement;
    }
  }, true);
})();
